import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export enum BrowserTitleKeys {
  accountConnections = 'accountConnections',
  accountSettings = 'accountSettings',
  analytics = 'analytics',
  auth = 'auth',
  emailReports = 'emailReports',
  forbidden = 'forbidden',
  home = 'home',
  keywordAnalysis = 'keywordAnalysis',
  listings = 'listings',
  locationDetails = 'locationDetails',
  locations = 'locations',
  menus = 'menus',
  notFound = 'notFound',
  reviewAnalysis = 'reviewAnalysis',
  reviewLabels = 'reviewLabels',
  reviewMonitoring = 'reviewMonitoring',
  reviewNotifications = 'reviewNotifications',
  reviewResponsePrompts = 'reviewResponsePrompts',
  reviewTemplates = 'reviewTemplates',
  sentimentAnalysis = 'sentimentAnalysis',
  socialManagement = 'socialManagement',
  userManagement = 'userManagement',
  userProfile = 'userProfile',
}

type UseBrowserTitleProps =
  | {
      titleKey: BrowserTitleKeys
      customTitle?: never
    }
  | {
      titleKey?: never
      customTitle: string
    }

export function useBrowserTitle({ titleKey, customTitle }: UseBrowserTitleProps) {
  const { t } = useTranslation()
  useEffect(() => {
    const prefix = t('browserTitle.prefix')
    const suffix = t('browserTitle.suffix')

    if (titleKey) {
      const title = t(`browserTitle.titles.${titleKey}`)
      document.title = `${prefix} ${title} ${suffix}`
      return
    }

    document.title = `${prefix} ${customTitle} ${suffix}`
  }, [customTitle, t, titleKey])
}
